// extracted by mini-css-extract-plugin
export default {"blocks-modal-container":"styles_blocks-modal-container__eOYRc"};